<div id="contenu" [ngClass]="{ 'cursor-wait': loading }">
  <div id="aPropos" *ngIf="valueDisplay">
    <div class="infoPart">
      <div class="withArrow">
        <div class="retourArrow" (click)="retour()">
          <img src="../../../../../assets/img/arrow.svg" alt="" />
        </div>
        <h3 class="titrePanel">
          Vos coordonnées
          <span class="margespan">
            <button class="updateBTN" type="button" (click)="retourUpdate()">
              Modifier
            </button>
          </span>
        </h3>
      </div>
      <h4 class="panelInfo">
        <span class="icon">
          <img [src]="'../../../../../../assets/img/' + avatar" alt=""
        /></span>
        {{ Civilite(valueDisplay.assurees.assurePrincipal.sexe) }}
        {{ valueDisplay.assurees.assurePrincipal.prenom }}
        {{ valueDisplay.assurees.assurePrincipal.nom }}
        <span class="margespan">
          {{ valueDisplay.assurees.assurePrincipal.num_SS }}
        </span>
      </h4>
      <p class="greyColor2 panelInfo">
        <span class="icon">
          <img [src]="'../../../../../../assets/img/' + pousette" alt=""
        /></span>
        Né(e) le :
        {{ formatDateNaissanceAssure }}
        <span class="margespan" *ngIf="souscription">{{
          souscription.lieuNaissanceSouscripteur
        }}</span>
        <span class="margespan" *ngIf="valueDisplay && valueDisplay.assurees"
          >{{ valueDisplay.assurees.paysNaissance }}
        </span>
      </p>
      <p class="greyColor2 panelInfo" *ngIf="valueDisplay.subscribe">
        <span class="icon">
          <img [src]="'../../../../../../assets/img/' + location" alt=""
        /></span>
        {{ valueDisplay.subscribe.adresseSouscripteur }} ,{{
          valueDisplay.subscribe.adresseComplementSouscripteur
        }}
      </p>
      <p class="greyColor2 panelInfo" *ngIf="personne">
        <span class="icon">
          <img [src]="'../../../../../../assets/img/' + mail_small" alt=""
        /></span>
        {{ personne.email }}
      </p>
      <p class="greyColor2 panelInfo" *ngIf="personne">
        <span class="icon">
          <img [src]="'../../../../../../assets/img/' + phone" alt=""
        /></span>
        {{ personne.telephone }}
      </p>
      <p class="greyColor2 panelInfo" *ngIf="personne">
        <span class="icon">
          <img [src]="'../../../../../../assets/img/' + parapluie" alt=""
        /></span>
        {{ RegimeSocial(personne.regimeSocial) }} Code d'organisme
        {{ getCodeOrganisme(valueDisplay.assurees.assurePrincipal.orga) }}
      </p>
    </div>
    <div
      class="infoPart benef"
      *ngIf="
        valueDisplay &&
        valueDisplay.assurees &&
        (valueDisplay.assurees.isConjoint || valueDisplay.assurees.isEnfants)
      "
    >
      <div class="withArrow">
        <h3 class="titrePanel">
          Vos bénéficiaires
          <span class="margespan"> </span>
        </h3>
      </div>

      <ng-container
        *ngIf="
          valueDisplay.assurees &&
          valueDisplay.assurees.isConjoint &&
          valueDisplay.assurees.assureConjoint.dateNaissance
        "
      >
        <h4 class="panelInfo">
          <span class="icon">
            <img [src]="'../../../../../../assets/img/' + avatar" alt=""
          /></span>
          {{ Civilite(valueDisplay.assurees.assureConjoint.sexe) }}
          {{ valueDisplay.assurees.assureConjoint.prenom }}
          {{ valueDisplay.assurees.assureConjoint.nom }}
          <span class="margespan greyColor2"
            >Né(e) le
            <!-- <span *ngIf="valueDisplay.assurees.assureConjoint.sexe == 1">e</span> le -->
            {{
              getDateInstance(
                valueDisplay.assurees.assureConjoint.dateNaissance
              ) | date: 'dd/MM/yyyy'
            }}</span
          >
        </h4>

        <p class="greyColor panelInfo">
          <span class="icon">
            <img
              [src]="'../../../../../../assets/img/' + parapluie"
              alt="" /></span
          >{{ RegimeSocial(valueDisplay.assurees.assureConjoint.regime) }}
        </p>
      </ng-container>
      <!-- {{ valueDisplay.assurees.isEnfants }} -->
      <ng-container
        *ngIf="valueDisplay.assurees && valueDisplay.assurees.isEnfants"
      >
        <ng-container
          *ngFor="let assureEnfant of valueDisplay.assurees.assureEnfants"
        >
          <h4 class="panelInfo">
            <span class="icon">
              <img [src]="'../../../../../../assets/img/' + avatar" alt=""
            /></span>
            {{ assureEnfant.prenom }} {{ assureEnfant.nom }}
            <span class="margespan greyColor2"
              >Né(e) le
              <!-- <span *ngIf="assureEnfant.sexe == 1">e</span> le -->
              {{
                getDateInstance(assureEnfant.dateNaissance) | date: 'dd/MM/yyyy'
              }}</span
            >
          </h4>

          <p *ngIf="assureEnfant.regime" class="greyColor panelInfo">
            <span class="icon">
              <img
                [src]="'../../../../../../assets/img/' + parapluie"
                alt="" /></span
            >{{ RegimeSocial(assureEnfant.regime) }}
          </p>
        </ng-container>
      </ng-container>
    </div>
  </div>
  <br />

  <div id="aPropos">
    <div class="infoPart" *ngIf="valueDisplay">
      <h3 class="titrePanel">
        Contrat et formule
        <span class="margespan">
          <button class="updateBTN" type="button" (click)="retourContrat()">
            Modifier
          </button></span
        >
      </h3>
      <p>
        <span class="greyColor"> Contrat débutant le :</span>
        <span class="fontSemiBold"> {{ formatDateDebutContrat }} </span>
      </p>
      <p>
        <span class="greyColor">Loi Madelin : </span>
        <span
          class="fontSemiBold"
          *ngIf="
            valueDisplay.tarifViewModel &&
            valueDisplay.tarifViewModel.LoiMadelin == false
          "
          >NON</span
        >
        <span
          class="fontSemiBold"
          *ngIf="
            valueDisplay.tarifViewModel &&
            valueDisplay.tarifViewModel.LoiMadelin == true
          "
          >OUI</span
        >
      </p>
      <p>
        <span class="greyColor">Contrat santé ou mutuelle : </span>
        <span
          class="fontSemiBold"
          *ngIf="
            valueDisplay.tarifViewModel &&
            valueDisplay.tarifViewModel.NoAncienneCompagnie == true
          "
          >OUI
        </span>
        <span
          class="fontSemiBold"
          *ngIf="
            valueDisplay.tarifViewModel &&
            valueDisplay.tarifViewModel.NoAncienneCompagnie == false
          "
          >NON
        </span>
      </p>
      <p>
        <span class="greyColor">Rythme du règlement : </span>
        <span
          class="fontSemiBold"
          *ngIf="
            valueDisplay.paiement &&
            valueDisplay.paiement.fractionnement &&
            valueDisplay.paiement.fractionnement == 1
          "
        >
          Mensuel</span
        >
        <span
          class="fontSemiBold"
          *ngIf="
            valueDisplay.paiement &&
            valueDisplay.paiement.fractionnement &&
            valueDisplay.paiement.fractionnement == 4
          "
        >
          Annuel</span
        >
      </p>
      <p class="NoWrap">
        <span class="greyColor">IBAN : </span>
        <span
          class="fontSemiBold"
          *ngIf="
            valueDisplay.paiement && valueDisplay.paiement.nomEtablissement
          "
          >{{ valueDisplay.paiement.nomEtablissement }} -
          {{ valueDisplay.paiement.iban }}
        </span>
      </p>
      <p>
        <span class="greyColor">BIC : </span>
        <span
          class="fontSemiBold"
          *ngIf="valueDisplay.paiement && valueDisplay.paiement.bic"
        >
          {{ valueDisplay.paiement.bic }}</span
        >
      </p>
    </div>

    <div id="formule" class="form3">
      <div *ngIf="tarif">
        <!-- <img class="scaleImg" src="../../../../../../assets/img/100FamilleSante.svg" alt="" /> -->
        <div class="recapOffre">
          <div class="recapImage">
            <img
              class="scaleImg"
              *ngIf="tarif && tarif.produitTarif == 'ESSENTIEL_PLUS_SANTE'"
              src="assets/img/Essentiel_Plus_Sante.svg"
              style="width: 90%"
              alt=""
            />

            <img
              class="scaleImg"
              *ngIf="tarif && tarif.produitTarif == 'ESSENTIEL_PLUS_SANTE_ECO'"
              src="assets/img/Essentiel_Plus_Sante_Eco.svg"
              style="width: 90%"
              alt=""
            />

            <img
              class="scaleImg"
              *ngIf="
                tarif &&
                (tarif.produitTarif == 'PREVOIR_IMM_SANTE_FAMILLE_ECO' ||
                  tarif.produitTarif == 'PREVOIR_IMM_SANTE_FAMILLE')
              "
              src="assets/img/100FamilleSante.svg"
              style="width: 90%"
              alt=""
            />
            <img
              class="scaleImg"
              *ngIf="
                tarif &&
                (tarif.produitTarif == 'AESIO_IMM_SANTE_FAMILLE_ECO' ||
                  tarif.produitTarif == 'AESIO_IMM_SANTE_FAMILLE')
              "
              src="assets/img/100FamilleSante.svg"
              style="width: 90%"
              alt=""
            />
            <img
              class="scaleImg"
              *ngIf="tarif && tarif.produitTarif == 'RELAXEO2'"
              src="assets/img/Relaxeo.svg"
              alt=""
            />
            <img
              class="scaleImg"
              *ngIf="
                (tarif && tarif.produitTarif == 'AC_PRIVILEGE') ||
                tarif.produitTarif == 'MTX_OPTIMUM_SANTE'
              "
              src="assets/img/OptimumSante.svg"
              alt=""
            />

            <img
              class="scaleImg"
              *ngIf="tarif && tarif.produitTarif == 'CEGEMAV'"
              src="assets/img/vitaneor.svg"
              alt=""
            />
            <img
              class="scaleImg"
              *ngIf="tarif && tarif.produitTarif == 'CEGE_EQUILIBRE'"
              src="assets/img/cegema-equilibre.svg"
              alt=""
            />
            <img
              class="scaleImg"
              *ngIf="
                tarif &&
                (tarif.produitTarif == 'CEGEMA_FLEXI_SANTE_NON_RESPONSABLE' ||
                  tarif.produitTarif == 'CEGEMA_FLEXI_SANTE_RESPONSABLE')
              "
              src="assets/img/cegema-flexibilite.svg"
              alt=""
            />
            <img
              class="scaleImg"
              *ngIf="tarif && tarif.produitTarif == 'KEREIS_SERENITE'"
              src="assets/img/cegema-serenite-sante.svg"
              alt=""
            />
            <img
              class="scaleImg"
              *ngIf="tarif && tarif.produitTarif == 'ESS_SANTE_SENIOR'"
              src="assets/img/Essentiel_Sante_Senior.svg"
              alt=""
            />

            <img
              class="scaleImg"
              *ngIf="tarif && tarif.produitTarif == 'ESS_SANTE_FAMILLE'"
              src="assets/img/Essentiel_Sante_Famille.svg"
              alt=""
            />
            <img
              class="scaleImg"
              *ngIf="
                tarif && tarif.produitTarif == 'PREVOIR_IMM_SANTE_SENIOR_ECO'
              "
              src="assets/img/aesio_imm_senior_eco.svg"
              alt=""
            />

            <img
              class="scaleImg"
              *ngIf="
                tarif && tarif.produitTarif == 'AESIO_IMM_SANTE_SENIOR_ECO'
              "
              src="assets/img/aesio_imm_senior_eco.svg"
              alt=""
            />

            <img
              class="scaleImg"
              *ngIf="tarif && tarif.produitTarif == 'PREVOIR_IMM_SANTE_SENIOR'"
              src="assets/img/aesio_imm_senior.svg"
              alt=""
            />

            <img
              class="scaleImg"
              *ngIf="tarif && tarif.produitTarif == 'AESIO_IMM_SANTE_SENIOR'"
              src="assets/img/aesio_imm_senior.svg"
              alt=""
            />
            <img
              class="scaleImg"
              *ngIf="
                tarif &&
                tarif.produitTarif == 'MEILLEURTAUX_VITA_SANTE_55_PLUS_NR'
              "
              src="assets/img/mtx_vita_sante_plus55.svg"
              alt=""
            />

            <img
              class="scaleImg"
              *ngIf="
                tarif &&
                tarif.produitTarif == 'MEILLEURTAUX_VITA_SANTE_FAMILLE_NR'
              "
              src="assets/img/mtx_vita_sante_famille.svg"
              alt=""
            />
            <img
              class="scaleImg"
              *ngIf="tarif && tarif.produitTarif == 'CEGEMAEss'"
              src="assets/img/essentiel2.svg"
              alt=""
            />

            <img
              class="scaleImg"
              *ngIf="tarif && tarif.produitTarif == 'VITAMIN3'"
              src="assets/img/apivia.png"
              alt=""
            />

            <img
              class="scaleImg"
              *ngIf="tarif && tarif.produitTarif == 'PARTICULIER'"
              src="assets/img/SLPart.svg"
              alt=""
            />

            <img
              class="scaleImg"
              *ngIf="tarif && tarif.produitTarif == 'SWLF_RETRAITES'"
              src="assets/img/SLSenior.svg"
              alt=""
            />

            <img
              class="scaleImg"
              *ngIf="tarif && tarif.produitTarif == 'PROGR_SANTE_FAMILLE'"
              src="assets/img/prog_sante_famille.svg"
              alt=""
            />

            <img
              class="scaleImg"
              *ngIf="tarif && tarif.produitTarif == 'PROGR_SANTE_SENIOR'"
              src="assets/img/prog_sante_senior.svg"
              alt=""
            />

            <img
              class="scaleImg"
              *ngIf="tarif && tarif.produitTarif == 'ZEN_SANTE_FAMILLE'"
              src="../../../../../../assets/img/Zenioo_Sante_Famille.svg"
              alt=""
            />
            <img
              class="scaleImg"
              *ngIf="tarif && tarif.produitTarif == 'ZEN_SANTE_55_PLUS'"
              src="../../../../../../assets/img/Zenioo_Sante_55Plus.svg"
              alt=""
            />
            <img
              class="scaleImg"
              *ngIf="tarif && tarif.produitTarif == 'ZEN_SANTE_SENIOR'"
              src="../../../../../../assets/img/Zenioo_Sante_Senior.svg"
              alt=""
            />
            <img
              class="scaleImg"
              *ngIf="tarif && tarif.produitTarif == 'ZEN_SANTE_SENIOR_ECO'"
              src="../../../../../../assets/img/Zenioo_Sante_Senior_Eco.svg"
              alt=""
            />
          </div>
        </div>
      </div>
      <div id="prixFormule" *ngIf="tarif">
        <!-- <p class="pFormule"> -->
        <!-- <b class="pFormule33">33,</b>89€ /mois</p> -->
        <div class="mensuel">
          <span class="prix">{{
            (ate(tarif.montant) | number: '1.1-2')?.split('.')?.[0] || '0'
          }}</span>
          <span class="prixCentimes"
            >,{{
              (ate(tarif.montant) | number: '1.1-2')?.split('.')?.[1] || '00'
            }}</span
          >
          <span class="prix">€</span>/mois
        </div>
        <!-- <p class="gris"> -->
        <div class="annuel">
          Soit {{ ate(tarif.montant) * 12 | number: '1.1-2' : 'fr' }}€/an tout
          inclus
        </div>
        <!-- </p> -->
      </div>
    </div>
  </div>

  <div id="bullAd">
    <div class="bullADEntete">
      <h3 class="titrePanel">Votre bulletin d’adhésion</h3>

      <div
        *ngIf="generatePdf && AdhesionDocResponse != null"
        class="DocBTNContainer"
      >
        <button
          class="DocBTN"
          (click)="showBulletinAdhesionDialog()"
          [ngStyle]="{
            background: origine ? btn_bg : '#6D3311',
          }"
        >
          <img src="assets/img/afficher.png" width="30" alt="" />
        </button>
        <button
          class="DocBTN"
          (click)="onClickDownloadPdf()"
          [ngStyle]="{
            background: origine ? btn_bg : '#6D3311',
          }"
        >
          <img src="assets/img/telechargement.png" width="30" alt="" />
        </button>
      </div>
    </div>
    <iframe
      id="ifrm"
      style="width: 100%; height: 200px; position: relative"
      scrolling="no"
    ></iframe>
  </div>

  <div id="offreChoose" *ngIf="tarif">
    <p class="displaySplit">
      <span class="FontPoppoins16_20"> Offre choisie </span>
      <span class="FontPoppoins26_20">
        <b>
          {{ (ate(tarif.montant) | number: '1.1-2')?.split('.')?.[0] || '0' }} ,
          {{ (ate(tarif.montant) | number: '1.1-2')?.split('.')?.[1] || '00' }}
        </b>
        € /mois</span
      >
    </p>

    <div>
      <div class="custom-list">
        <div *ngIf="cotisationAPSAP != null && cotisationAPSAP != ''">
          <li>
            <strong>{{ textCotisationAPSAP }}</strong> (frais inclus dans les
            frais de l'offre choisie)
          </li>
          <span class="FontPoppoins26_20 fr">
            <b>{{ cotisationAPSAP }}</b> € /mois
          </span>
        </div>
        <div *ngIf="fraisFractionnement != null && fraisFractionnement != ''">
          <li>
            <strong>Frais de fractionnement</strong> (frais inclus dans les
            frais de l'offre choisie)
          </li>
          <span class="FontPoppoins26_20 fr">
            <b>{{ fraisFractionnement }}</b> € /mois
          </span>
        </div>
        <div *ngIf="tarif.produitTarif.includes('ZEN_SANTE')">
          <li>
            <strong>Cotisation de l’association des assurés Zenioo</strong>
          </li>
          <span class="FontPoppoins26_20 fr">
            <b>{{ cotisationAssuresZenioo }}</b> € /mois
          </span>
        </div>
      </div>
    </div>

    <p
      class="Frais-container"
      style="display: flex; justify-content: space-between"
    >
      <span class="FontPoppoins16_20">
        Frais de dossier (à payer une seule fois à la souscription initiale)
      </span>
      <span *ngIf="fraisDeDossier; else noFraisDeDossier"
        ><b style="font-weight: 16px">{{ fraisDeDossier }}€</b></span
      >

      <ng-template #noFraisDeDossier>
        <span
          *ngIf="
            !!tarif &&
            tarif.produitTarif != 'ZEN_SANTE_SENIOR_ECO' &&
            tarif.produitTarif != 'ZEN_SANTE_SENIOR' &&
            tarif.produitTarif != 'ZEN_SANTE_55_PLUS' &&
            tarif.produitTarif != 'ZEN_SANTE_FAMILLE'
          "
          class="FontPoppoins26_20"
        >
          <b style="font-weight: 16px">20€ </b></span
        >
        <span
          *ngIf="
            tarif.produitTarif == 'ZEN_SANTE_SENIOR_ECO' ||
            tarif.produitTarif == 'ZEN_SANTE_SENIOR' ||
            tarif.produitTarif == 'ZEN_SANTE_55_PLUS' ||
            tarif.produitTarif == 'ZEN_SANTE_FAMILLE'
          "
          class="FontPoppoins26_20"
        >
          <b style="font-weight: 16px">10€</b>
        </span>
      </ng-template>
    </p>

    <h3 class="displaySplit titrePanel">
      <span> Montant total annuel </span>
      <span
        class="text-orange tarifPrix"
        [ngStyle]="{ color: origine ? c_base : '#6D3311' }"
      >
        {{ ate(tarif.montant) * 12 | number: '1.1-2' : 'fr' }}&nbsp;€
      </span>
    </h3>
  </div>

  <div *ngIf="docName" id="AChecker">
    <h4 class="checkboxscale">
      <input
        class="je_reconnais"
        id="je_reconnais_id"
        type="checkbox"
        [(ngModel)]="condition0"
        [checked]="
          condition1 && condition2 && condition3 && condition4 && condition6
        "
        (change)="toutChecker($event)"
        (click)="onClickJeReconnais()"
      />
      <label for="je_reconnais_id"
        >Je reconnais avoir reçu et pris connaissance  :</label
      >
    </h4>
    <p>
      <input
        id="des_conditions"
        type="checkbox"
        [(ngModel)]="condition1"
        (change)="onConfirmeSiganture($event)"
      /><label for="des_conditions"> des </label>
      <a
        class="black-text underline"
        (click)="getDoc(tarif.produitTarif, docName.CG)"
        >conditions générales</a
      >
      du contrat valant notice d'information
    </p>
    <p>
      <input
        id="produit_assurance"
        type="checkbox"
        [(ngModel)]="condition2"
        (change)="onConfirmeSiganture($event)"
      /><label for="produit_assurance"> du </label>
      <a
        class="black-text underline"
        (click)="getDoc(tarif.produitTarif, docName.TG)"
        >tableau de garantie</a
      >
      et du
      <a
        class="black-text underline"
        (click)="getDoc(tarif.produitTarif, docName.FID)"
        >document d’information</a
      >
      normalisé (IPID)
    </p>
    <p>
      <input
        id="info_relative"
        type="checkbox"
        [(ngModel)]="condition4"
        (change)="onConfirmeSiganture($event)"
      /><label for="info_relative"> de l’information relative aux </label>
      <a
        class="black-text underline"
        (click)="getDoc(tarif.produitTarif, docName.FraisGestion)"
        >frais de gestion
      </a>
    </p>
    <p>
      <input
        id="conditions_souscription"
        type="checkbox"
        [(ngModel)]="condition3"
        (change)="onConfirmeSiganture($event)"
      /><label for="conditions_souscription"> de </label>
      <a
        class="black-text underline"
        (click)="getDoc(tarif.produitTarif, docName.AnnexeVAD)"
        >l'Annexe sur le droit de renonciation et procédure de réclamations</a
      >
    </p>

    <p *ngIf="statusAPSAP && statusAPSAP != ''">
      <input
        id="status_apsap"
        type="checkbox"
        [(ngModel)]="condition6"
        (change)="onConfirmeSiganture($event)"
      /><label for="status_apsap">{{ statusAPSAP }}</label>
    </p>

    <p>
      <input
        id="recevoir_communications"
        type="checkbox"
        [(ngModel)]="condition5"
        (change)="onConfirmeSiganture($event)"
      /><label for="recevoir_communications">
        J’accepte de recevoir des communications commerciales de Meilleurtaux
        Santé et de ses partenaires</label
      >
    </p>
  </div>
  <!-- *** Je déclare *** -->
  <div *ngIf="declaration" id="AChecker">
    <h4 class="checkboxscale">
      <input
        id="checkbox1"
        type="checkbox"
        [checked]="allDeclarationChecked"
        [indeterminate]="someDeclarationChecked()"
        (change)="setAllDeclarationChecked($event)"
      />
      <label for="checkbox1" [innerText]="declaration.content"></label>
    </h4>

    <p
      *ngFor="let subDeclaration of declaration.subDeclarations; let i = index"
    >
      <input
        [id]="'checkbox2' + i"
        type="checkbox"
        [(ngModel)]="subDeclaration.checked"
        (change)="updateAllDeclaration()"
      />
      <label
        [for]="'checkbox2' + i"
        [innerHTML]="subDeclaration.content"
      ></label>
    </p>
  </div>

  <!-- <p *ngIf="erreurSignature != '' " class="alert alert-danger text-center">
    {{ erreurSignature}}
  </p> -->
  <div id="SignerContrat">
    <button
      class="signer"
      type="button"
      (click)="signerContrat('signer')"
      [ngClass]="{
        gray: true,
        orange:
          condition0 &&
          condition1 &&
          condition2 &&
          condition3 &&
          condition4 &&
          condition6 &&
          allDeclarationChecked,
      }"
      [disabled]="
        loading ||
        !condition0 ||
        !condition1 ||
        !condition2 ||
        !condition3 ||
        !condition4 ||
        !condition6 ||
        !allDeclarationChecked
      "
      [ngStyle]="{
        background: origine ? btn_bg : '#6D3311',
      }"
    >
      <div *ngIf="loading" class="spinner-border text-light" role="status">
        <span class="sr-only">Traitement...</span>
      </div>
      Signer mon contrat
      <span class="marginLeft">
        <img src="../../../../../../assets/img/editPen.svg" alt=""
      /></span>
    </button>
  </div>

  <div id="SignElectro" style="display: none">
    <h3 class="titrePanel">Signature électronique</h3>
    <div class="ligneForm">
      <div class="FormGauche">
        <p><label> Téléphone portable</label></p>
        <p *ngIf="personne">
          <input type="text" [(ngModel)]="personne.telephone" />
        </p>
      </div>
      <div class="FormDroite" *ngIf="noPortable">
        <p><label>Adresse email</label></p>
        <p *ngIf="personne">
          <input type="text" [(ngModel)]="personne.email" />
        </p>
      </div>
    </div>
    <p class="noPhone">
      <input
        id="telephone_portable"
        type="checkbox"
        [(ngModel)]="noPortable"
      /><label for="telephone_portable">
        Je n’ai pas de téléphone portable</label
      >
    </p>
    <p>
      En cliquant sur le bouton ci-dessous, vous allez recevoir sur votre
      téléphone mobile ou par email un code pour
      <b>valider définitivement votre signature électronique.</b>
    </p>

    <div>
      <button
        class="signer marginTop3"
        type="button"
        (click)="signerContrat('recevoirCode')"
        [ngClass]="{
          gray: true,
          orange:
            condition0 &&
            condition1 &&
            condition2 &&
            condition3 &&
            condition4 &&
            condition6,
        }"
        [disabled]="
          loading ||
          !condition0 ||
          !condition1 ||
          !condition2 ||
          !condition3 ||
          !condition4 ||
          !condition6
        "
        [ngStyle]="{
          background: origine ? btn_bg : '#6D3311',
        }"
      >
        <div *ngIf="loading" class="spinner-border text-light" role="status">
          <span class="sr-only">Traitement...</span>
        </div>
        Recevoir le code de signature
        <span class="margespan">
          <img src="../../../../../../assets/img/editPen.svg" alt=""
        /></span>
      </button>
    </div>
  </div>

  <form
    #formulaire="ngForm"
    [formGroup]="formulaireFormGroup"
    id="formulaire-signature"
  >
    <div id="SignElectro2" style="display: none">
      <h3 class="titrePanel">Signature électronique</h3>
      <div class="ligneForm">
        <div class="FormGauche">
          <p><label> Code de signature</label></p>
          <p>
            <input
              formControlName="codeCtrl"
              type="text"
              [(ngModel)]="code"
              inputmode="numeric"
              mask="000000"
              [ngClass]="{
                'ng-invalid': codeInvalid.status == 'invalide',
                'ng-touched': codeInvalid.status == 'invalide',
              }"
            />
          </p>
          <p
            *ngIf="
              codeInvalid.status ||
              ((codeCtrl.hasError('required') ||
                codeCtrl.hasError('invalid') ||
                codeCtrl.hasError('pattern')) &&
                (codeCtrl.dirty || codeCtrl.touched))
            "
            class="error-msg"
          >
            <span *ngIf="codeInvalid.status != 'invalide'"
              >Code signature invalide.</span
            >
            <span *ngIf="codeInvalid.status == 'invalide'">{{
              codeInvalid.message
            }}</span>
          </p>
        </div>
      </div>
      <div>
        <button
          class="signer marginTop3"
          type="button"
          (click)="signerContrat('verifierCode')"
          [ngClass]="{
            gray: true,
            orange:
              !formulaire.invalid &&
              condition0 &&
              condition1 &&
              condition2 &&
              condition3 &&
              condition4,
          }"
          [disabled]="
            loading ||
            formulaire.invalid ||
            !condition0 ||
            !condition1 ||
            !condition2 ||
            !condition3 ||
            !condition4
          "
          [ngStyle]="{
            background: origine ? btn_bg : '#6D3311',
          }"
        >
          <div *ngIf="loading" class="spinner-border text-light" role="status">
            <span class="sr-only">Traitement...</span>
          </div>
          Signer mon contrat
          <span class="margespan">
            <img src="../../../../../../assets/img/editPen.svg" alt=""
          /></span>
        </button>
      </div>
    </div>
  </form>
</div>
